<template>
  <div class="org-modal">
    <div class="modal fade" data-bs-backdrop="static" id="orgUnitDeleteModal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" v-draggable-modal>
        <div v-if="elementType" class="modal-content bg-primary">

          <div class="modal-header">
            <div class="h5 modal-title text-light">
              <span v-if="elementType === 'orgUnit'"> {{ $t("views.org.structure.headingDeleteOrgUnit") }} </span>
              <span v-if="elementType === 'member'"> {{ $t("views.org.structure.headingDeleteMember") }} </span>
            </div>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body bg-light">
            <div v-if="elementType === 'orgUnit'" class="text-center my-3">
              <p class="fw-bold">{{ this.selectedOrgUnit.name }}</p>
              <p> {{ $t("views.org.structure.confirmDeleteOrgUnit") }}</p>
            </div>
            <div v-if="elementType === 'member'" class="text-center my-3">
              <p class="fw-bold">{{ this.selectedElement }}</p>
              <p> {{ $t("views.org.structure.confirmDeleteMember") }}</p>
            </div>
          </div>

          <div class="modal-footer bg-light">
            <button type="button" class="btn btn-sm btn-outline-secondary" data-bs-dismiss="modal">{{ $t("general.close") }}</button>
            <button @click="deleteElement()" type="button" class="btn btn-sm btn-danger" data-bs-dismiss="modal">{{ $t("general.delete") }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrgUnitDeleteModal',
  mounted () {
    const myModalDialog = document.getElementById('orgUnitDeleteModal')

    myModalDialog.addEventListener('shown.bs.modal', event => {
      this.orgUnitModalElementName = this.$parent.orgUnitModalElementName
    })
  },
  data () {
    return {
      orgUnitModalElementName: ''
    }
  },
  computed: {
    selectedOrgUnit () {
      return this.$store.state.selectedOrgUnit
    },
    selectedElement () {
      return this.$parent.selectedElement
    },
    selectedRole () {
      return this.$parent.role
    },
    elementType () {
      return this.$parent.orgUnitModalElementType
    },
    mode () {
      return this.$parent.orgUnitModalMode
    }
  },
  methods: {
    async deleteElement () {
      try {
        this.$store.commit('SET_LOADING_STATUS', true)
        const elementId = this.$parent.orgUnitModalElementId
        if (this.elementType === 'orgUnit' && !this.selectedOrgUnit.hasNodes) {
          await this.$store.dispatch('deleteOrgUnit', this.selectedOrgUnit.id)
        } else {
          await this.$store.dispatch('deleteOrgUnitElement', { orgUnitId: this.selectedOrgUnit.id, elementType: (this.elementType + 's'), elementId })
        }
      } finally {
        this.$store.commit('SET_LOADING_STATUS', false)
      }
    }
  }
}
</script>
